import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '~/components/ui/breadcrumb'
import { Separator } from '~/components/ui/separator'
import { SidebarProvider, SidebarTrigger } from '~/components/ui/sidebar'
import Footer from '~/pages/backoffice/Footer'
import { AppSidebar } from '~/pages/backoffice/sidebar/AppSidebar'

function BackOfficeLayout() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const breadcrumb = pathname.split('/').filter(path => path !== 'back-office').filter(Boolean)

  return (
    <SidebarProvider>
      <div className="flex h-dvh overflow-hidden w-screen">
        <AppSidebar />
        <div className="flex flex-col justify-between w-full h-full overflow-hidden">
          <div className="p-5 flex flex-col gap-4 overflow-y-auto">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <SidebarTrigger />
                </BreadcrumbItem>
                <Separator orientation="vertical" />
                <BreadcrumbItem>
                  <BreadcrumbPage>{t('common.back-office')}</BreadcrumbPage>
                </BreadcrumbItem>
                {breadcrumb.map(item => (
                  <div key={item} className="flex justify-center items-center gap-1.5 sm:gap-2.5">
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      <BreadcrumbPage>{t(`common.routing.${item}`)}</BreadcrumbPage>
                    </BreadcrumbItem>
                  </div>
                ))}
              </BreadcrumbList>
            </Breadcrumb>
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </SidebarProvider>
  )
}

export default BackOfficeLayout
